<template>
	<v-dialog v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
			<v-card-title class="headline modal__title">
				<button type="button" class="btn-flat-icon--dark" @click="open=false"><v-icon large>fal fa-times</v-icon></button>
				<h4 style="color: #444" class="ml-3" v-if="type==='notifications'">Allow Notifications?</h4>
				<h4 style="color: #444" class="ml-3" v-else-if="type==='location'">Share Location?</h4>
			</v-card-title>
			<v-card-text>
				<p class="ma-0" style="font-size: 1.1em; color: #555" v-if="type==='notifications'">wrkprty.com would like to show notifications and alerts</p>
				<p class="ma-0" style="font-size: 1.1em; color: #555" v-else-if="type==='location'">wrkprty.com would like to know your location</p>
			</v-card-text>
			<v-card-actions>
				<v-btn class="success" style="width: 50%" @click="requestPermission">Allow</v-btn>
				<v-btn style="width: 50%" @click="open=false">Deny</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
	name: 'PermissionsPromptModal',
	methods: {
		...mapActions(['setModalOpen', 'reverseGeocode']),
		requestPermission () {
			this.open = false
			if (this.type === 'notifications') {
				if ('Notification' in window && navigator.serviceWorker) {
					Notification.requestPermission(function(status) {
						console.log('Notification permission status:', status);
					});
				}
			} else if (this.type === 'location') {
				if (navigator.geolocation) {
					if (navigator.hasOwnProperty('permissions')) {
						navigator.permissions.query({name: 'geolocation'}).then((result) => {
							if (result.state === 'granted') {
								// user has given permission for browser geolocation
								navigator.geolocation.getCurrentPosition((position) => {
									console.log(position)
									this.reverseGeocode(position)
								})
							}
						})
					} else {
						navigator.geolocation.getCurrentPosition((position) => {
							console.log(position)
							this.reverseGeocode(position)
						})
					}
				}
			}
		},
	},
	computed: {
		...mapGetters(['getModalProp']),
		open: {
			get() {
				return this.getModalProp('permissionsPromptModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'permissionsPromptModal', value: val })
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		},
		type () {
			return this.getModalProp('permissionsPromptModalType')
		}
	}
}
</script>
